import React from 'react';
import { SafeAreaView, StyleSheet, View, StatusBar } from 'react-native';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route } from './navigation/react-router';
import { Switch } from 'react-router-native';

import {
  Confirm,
  ConsolidatedSearch,
  IdCard,
  LoginPage,
  MovementPage,
  ScanCategories,
  PersonnelRecord,
} from './screens';
import { AppContext } from './context';
import './icons';

const App = () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AppContext>
        <StatusBar barStyle="light-content" />
        <SafeAreaView>
          <View style={styles.body}>
            <Switch>
              <Route exact path="/" component={IdCard} />
              <Route path="/home" component={IdCard} />
              <Route path={'/search-categories'} component={ScanCategories} />
              <Route path={'/personnel-record'} component={PersonnelRecord} />
              <Route path="/search/:state" component={ConsolidatedSearch} />
              <Route path="/movement" component={MovementPage} />
              <Route path="/confirm" component={Confirm} />
            </Switch>
          </View>
        </SafeAreaView>
      </AppContext>
    </QueryClientProvider>
  );
};

const styles = StyleSheet.create({
  body: {
    width: '100%',
    height: '100%',
  },
});

export default App;
